import React from 'react'
import { Flex, SVGButton } from '/app/src/component'

import style from './style.css'

class SearchField extends React.Component {

    constructor(props) {
        super(props);
        this._handleClickOutside = this._handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this._handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._handleClickOutside);
    }

    _handleClickOutside(e){
        //In English: Do not invoke onClickCloseModal if it contains Searchfield or searchbutton.
        //Search button has it own CloseModal that will be invoked.
        if ((this.props.searchRef && !this.props.searchRef.contains(e.target))
            && (this.props.searchButtonRef && !this.props.searchButtonRef.contains(e.target))) {
            this.props.onClickCloseModal('displaySearchField');
        }
    }

    focus() {
        this.searchInput.focus();
    }

    render () {
        //The inner wrapper needs to be delayed for better aesthethics
        return <Flex border={ this.props.display ? '1px solid lightgrey' : '0px'}
            borderRadius='10px' vAlignContent='center'
            position='absolute' right='0'>
            <Flex borderRadius='inherit' transition='width 0.3s, opacity 0.3s'
            w={ this.props.display ? '300px': '0px' } h='55px'
            bg='transparent' opacity={ this.props.display ? '100%' : '0'}>
                <Flex
                    opacity={ this.props.display ? '100%' : '0'}
                    transition={ this.props.display ? 'opacity 1s' : 'opacity 0s' }
                    vAlignContent='center'
                    z='1'
                    borderRadius='inherit'
                    className={style.InputWrapper}>
                    <Flex basis='50%'>
                        <input
                            placeholder='Sök...'
                            onChange={this.props.onChange}
                            onKeyPress={this.props.onKeyPress}
                            value={this.props.value}
                            className={style.textInput}
                            ref={(input) => { this.searchInput = input; }}
                        />
                    </Flex>
                    <SVGButton
                        marginLeft='auto'
                        src={'/images/Conversations_S.svg'}
                        active={this.props.searchType === 'ticket'}
                        hover='darkblue'
                        color='grey'
                        onClick={ () => this.props.changeSearchClick('ticketSearch')}
                    />
                    <SVGButton
                        marginRight='60px'
                        src={'/images/Customer_S.svg'}
                        active={this.props.searchType === 'customer'}
                        hover='darkblue'
                        color='grey'
                        onClick={ () => this.props.changeSearchClick('customerSearch')}
                    />
                </Flex>
            </Flex>
        </Flex>
    }
}

export default SearchField;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/SearchField/index.js